"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _SupportContact = _interopRequireDefault(require("./SupportContact"));

var _SubscriptionPackage = _interopRequireDefault(require("../../../../../common/components/SubscriptionPackage"));

require("../styles/_subscription.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SHOOTSTA_CONTACT = {
  name: 'Shootsta',
  phoneNumber: '0412 345 678',
  iconName: 'shootstacolour'
};

var Subscription = /*#__PURE__*/function (_Component) {
  _inherits(Subscription, _Component);

  var _super = _createSuper(Subscription);

  function Subscription() {
    var _this;

    _classCallCheck(this, Subscription);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderContacts", function () {
      var accountManager = _this.props.accountManager;
      var supportContacts = accountManager ? [_objectSpread(_objectSpread({}, accountManager), {}, {
        name: (0, _getUserFullName.default)(accountManager),
        role: 'Account Manager'
      }), SHOOTSTA_CONTACT] : [SHOOTSTA_CONTACT];
      return /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
        rounded: true,
        className: "subscription__container__contacts"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading4: true,
        prefixIcon: "faq"
      }, "Contact Support"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        label: true
      }, "You can also contact us through live chat in the navigation menu"), supportContacts.map(function (contact, index) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SupportContact.default, _extends({
          key: contact.name
        }, contact)), index !== supportContacts.length - 1 && /*#__PURE__*/_react.default.createElement("hr", null));
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleButtonClick", function () {
      var history = _this.props.history;
      history.push('/manage-subscription');
    });

    return _this;
  }

  _createClass(Subscription, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hasManagePermission = _this$props.hasManagePermission,
          containerSize = _this$props.containerSize,
          orgPackage = _this$props.orgPackage;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('subscription', {
          'subscription--small': containerSize.width < _vars.NUMERIC_MEDIA_SIZES.small
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "subscription__label"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        prefixIcon: "subscription",
        heading3: true,
        noMargin: true
      }, "Subscription"), hasManagePermission ? /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        type: "SECONDARY",
        small: true,
        onClick: this.handleButtonClick
      }, "Manage Subscription") : null), /*#__PURE__*/_react.default.createElement("div", {
        className: "subscription__container"
      }, /*#__PURE__*/_react.default.createElement(_SubscriptionPackage.default, {
        orgPackage: orgPackage
      }), this.renderContacts()));
    }
  }]);

  return Subscription;
}(_react.Component);

exports.default = Subscription;